export default "__VITE_ASSET__Bi3p8UHE__"